// The exposures a unit can have. Kept in one place because the list is used by
// the admin dropdown, the catalogue table and the unit page — they used to
// carry three separate copies that could drift apart.
export const EXPOSURES = [
  { value: 'north', label: 'Север' },
  { value: 'south', label: 'Юг' },
  { value: 'east', label: 'Изток' },
  { value: 'west', label: 'Запад' },
  { value: 'northeast', label: 'Североизток' },
  { value: 'northwest', label: 'Северозапад' },
  { value: 'southeast', label: 'Югоизток' },
  { value: 'southwest', label: 'Югозапад' },
  { value: 'north-south', label: 'Север-Юг' },
  { value: 'east-west', label: 'Изток-Запад' },
] as const;

// Falls back to the stored value so units saved with an older or custom
// exposure still show something readable.
export const getExposureText = (exposure: string): string =>
  EXPOSURES.find((e) => e.value === exposure)?.label || exposure || '-';
